import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PreferencesState {
  preferredCurrency: string;
  setPreferredCurrency: (currency: string) => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      preferredCurrency: '',
      setPreferredCurrency: (currency) => set({ preferredCurrency: currency }),
    }),
    { name: 'pbf-portal-preferences' },
  ),
);
